module.exports = __webpack_public_path__ + "static/2d-b47049d1963bd03c71d8b0ad367a9f6a.jpg";